import axios from 'axios';

async function loadConfig() {
    try {
        const response = await axios.get('config.json');
        return response;
    } catch (error) {
        console.error('Falha ao carregar configuração', error);
        throw error;
    }
}

async function createInstance(params) {
    const config = await loadConfig();
    return axios.create({
        baseURL: config.data.servicoPrinter
    })
}


export async function listarJob(AcNumber) {
    const instance = await createInstance();
    try {
        const endpoint = `/Job/PostListarJobs`;
        const response = await instance.post(endpoint, { AcNumber });
        return response.data;
    } catch (error) {
        console.error('Erro ao listar os jobs:', error);
        return false;
    }
}

export async function BuscarImagensLista(jobId) {
    const instance = await createInstance();
    try {
        const endpoint = '/Job/PostBuscarImagensListaResult';
        const response = await instance.post(endpoint, { Id: jobId });
        return response.data;
    } catch (error) {
        console.error('Erro ao carregar lista de imagens', error);
        throw error;
    }
}

export async function GetProgress(jobId) {
    const instance = await createInstance();
    try {
        const endpoint = `/Printer/GetProgress`;
        const response = await instance.get(endpoint, {
            params: { Id: jobId }
        });
        document.getElementById('progress').innerText = `(${response.data.progress}%)`;
        return response;
    } catch (error) {
        console.error('Erro ao buscar progresso', error);
        throw error;
    }
}

export async function GetProgressList(jobs) {
    const instance = await createInstance();
    try {
        const endpoint = '/Printer/GetProgressList';
        const response = await instance.get(endpoint, {
            params: { Id: jobs }
        });
        document.getElementById('progress').innerText = `(${response.data.progress}%)`;
        return response;
    } catch (error) {
        console.error('Erro ao buscar progresso', error);
        throw error;
    }
}

export async function PrintJobId(jobId) {
    const instance = await createInstance();
    try {
        const endpoint = '/Printer/PostExtractPDF';
        const response = await instance.post(endpoint, { Id: jobId }, { responseType: 'blob' });
        return response;
    } catch (error) {
        console.error('Erro ao imprimir job', error);
        throw error;
    }
}

export async function PrintAllJobs(jobs) {
    const instance = await createInstance();
    try {
        const endpoint = '/Printer/PostExtractAllJobsPDF';
        const response = await instance.post(endpoint, jobs, { responseType: 'blob' });
        return response;
    } catch (error) {
        console.error('Erro ao imprimir todos os jobs', error);
        throw error;
    }
}
